/* eslint-disable @typescript-eslint/no-explicit-any */
import type { AxiosResponse } from 'axios';
import { call, delay, put, takeLatest } from 'redux-saga/effects';

import api from '../../api/api';
import { errorHandling } from '../../api/errorHandling';
import * as commonSagas from '../_common/commonSagas';
import { apiVersion } from '../apiVersion';
import * as spySlice from './spySlice';
import type { SpyPhoto } from './spySlice';

function* getSpyPhotosSaga(props: { type: string; payload: number }) {
	try {
		const version = apiVersion.spy.getSpyPhotos;
		const response: AxiosResponse<SpyPhoto[]> = yield call(
			api.get,
			`/Spy/v${version}/peakphotos/${props.payload}`,
		);

		yield put(spySlice.getSpyPhotosSuccess(response.data));
		yield delay(0);
		yield put(spySlice.getSpyPhotosFinish());
	} catch (error: unknown) {
		yield* errorHandling(error, spySlice.getSpyPhotosFailure);
	}
}

export default function* watchSpySaga() {
	yield takeLatest(spySlice.getTableStart.type, commonSagas.getTable);
	yield takeLatest(spySlice.getItemStart.type, commonSagas.getItem);
	yield takeLatest(spySlice.createItemStart.type, commonSagas.createItem);
	yield takeLatest(spySlice.updateItemStart.type, commonSagas.updateItem);
	yield takeLatest(spySlice.deleteItemsStart.type, commonSagas.deleteItems);
	yield takeLatest(spySlice.deleteItemStart.type, commonSagas.deleteItem);
	yield takeLatest(
		spySlice.getTableStructureStart.type,
		commonSagas.getTableStructure,
	);
	yield takeLatest(
		spySlice.getItemDocumentsStart.type,
		commonSagas.getItemDocuments,
	);
	yield takeLatest(
		spySlice.uploadItemDocumentsStart.type,
		commonSagas.uploadItemDocuments,
	);
	yield takeLatest(
		spySlice.deleteItemDocumentStart.type,
		commonSagas.deleteItemDocument,
	);
	yield takeLatest(spySlice.getTableExcelStart.type, commonSagas.getTableExcel);

	yield takeLatest(spySlice.getSpyPhotosStart.type, getSpyPhotosSaga);
}
